import { createStyles, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Dialog, Typography } from '@nutrien/cxp-components';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { observer } from 'mobx-react-lite';
import React from 'react';

dayjs.extend(utc);

const useStyles = makeStyles(() =>
  createStyles({
    outerGrid: {
      padding: '25px 0px 25px 0px',
    },
    buttonText: {
      letterSpacing: '1.25px',
    },
    text: {
      width: '100%',
      fontSize: 16,
      fontWeight: 300,
      letterSpacing: '0.15px',
      color: 'rgba(255, 255, 255, 0.87)',
    },
    confirmationOnAssignGrid: {
      padding: '25px 0px 25px 0px',
    },
  }),
);

interface Props {
  open: boolean;
  onClose: () => void;
  isLoading: boolean;
  onSave: () => Promise<void>;
  header: string;
  message: string;
  confirmMessage: string;
}

const ConfirmationOnAssign: React.FC<Props> = ({
  open,
  onClose,
  isLoading,
  onSave,
  header,
  message,
  confirmMessage,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      onClose={onClose}
      open={open}
      titleText={header}
      backButton={false}
      dialogActions={
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item>
            <Button
              className={classes.buttonText}
              variant="outlined"
              color="primary"
              noMinHeight
              onClick={onClose}
            >
              <Typography fontWeight={700}>Cancel</Typography>
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonText}
              noMinHeight
              isLoading={isLoading}
              onClick={onSave}
              data-testid="assignOrsubmitButton"
            >
              <Typography fontWeight={700}>{`Yes, ${confirmMessage}`}</Typography>
            </Button>
          </Grid>
        </Grid>
      }
      maxWidth="xs"
      noMinHeight
    >
      <Grid container className={classes.confirmationOnAssignGrid}>
        <Grid item container xs={12} alignItems="center">
          <Typography className={classes.text}>{message}</Typography>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default observer(ConfirmationOnAssign);
